export default __webpack_public_path__ + "static/28k-gigatons-inset-637c3560f6de762aff03b126765f3994.png";